var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCanonEf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 400 200",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M44.069,79.189C44.069,76.449 44.216,67.709 45.389,62.136C48.289,48.355 55.956,42.725 73.104,40.211C83.244,38.724 94.656,38.156 114.687,38.156C133.205,38.156 166.976,40.233 188.147,42.209L188.147,8.258C164.031,5.956 132.429,4.762 109.951,4.762C76.847,4.762 58.395,6.656 42.851,11.665C19.213,19.347 6.333,37.753 4.798,65.622C4.224,76.315 3.569,88.189 3.569,99.998C3.569,111.831 4.224,123.707 4.798,134.398C6.333,162.271 19.213,180.678 42.851,188.358C58.395,193.365 76.847,195.238 109.951,195.238C132.429,195.238 164.031,194.064 188.147,191.765L188.147,157.816C166.976,159.787 133.205,161.864 114.687,161.864C94.656,161.864 83.244,161.302 73.104,159.811C55.956,157.296 48.289,151.645 45.389,137.885C44.216,132.315 44.069,123.551 44.069,120.831L44.069,115.904L184.716,115.904L184.716,82.585L44.069,82.585L44.069,79.189M252.955,193.704L252.989,121.125L391.096,121.125L391.096,87.809L252.989,87.809C252.989,87.809 252.931,74.782 253.373,67.733C254.522,49.913 263.207,42.658 280.058,40.382C290.229,39.015 303.573,38.156 323.616,38.156C342.136,38.156 375.26,39.807 396.431,41.789L396.431,7.829C372.318,5.531 341.345,4.762 318.878,4.762C285.775,4.762 265.971,6.78 250.055,11.88C225.773,19.684 213.602,37.335 213.602,77.598C213.602,88.315 213.578,193.704 213.578,193.704L252.955,193.704",
    fill: "currentColor",
    style: {
      fillRule: "nonzero"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanonEf);
export default __webpack_public_path__ + "static/media/canon_ef.b9023fd372ba312105b904398ce22090.svg";
export { ForwardRef as ReactComponent };